module.exports = __webpack_public_path__ + "img/countdown2.c2c9ee02.gif";